import loadable from '@loadable/component';
import { WithLazyHydration } from '../../../WithLazyHydration';

const InlineGalleryLoadable = loadable(() => import('./InlineGallery'), {
  resolveComponent: components => components.InlineGallery
});

export const InlineGallery = WithLazyHydration(InlineGalleryLoadable, {
  name: 'InlineGallery'
});
